import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Box, CircularProgress } from '@mui/material';

// Fix Leaflet icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png'
});

// Component to handle map clicks
const LocationMarker = ({ position, setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    }
  });
  
  return position ? <Marker position={position} /> : null;
};

// Component to control map view
const MapController = ({ position }) => {
  const map = useMap();
  
  useEffect(() => {
    if (position) {
      try {
        map.setView(position, map.getZoom());
      } catch (e) {
        console.error("Error setting map view:", e);
      }
    }
  }, [position, map]);
  
  return null;
};

const MapEditor = ({ position, setPosition, height = '300px' }) => {
  const [isMapReady, setIsMapReady] = useState(false);
  
  // Force map to update size when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      setIsMapReady(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Ensure Leaflet is available in the browser environment
  if (typeof window === 'undefined' || !window.L) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height={height} 
        width="100%"
      >
        <CircularProgress size={40} />
      </Box>
    );
  }
  
  const defaultPosition = position || { lat: 52.2297, lng: 21.0122 }; // Default to Warsaw
  
  return (
    <MapContainer
      center={[defaultPosition.lat, defaultPosition.lng]}
      zoom={13}
      style={{ height, width: '100%' }}
      key={`editor-${defaultPosition.lat}-${defaultPosition.lng}-${isMapReady ? 'ready' : 'loading'}`}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <LocationMarker position={position} setPosition={setPosition} />
      <MapController position={position} />
    </MapContainer>
  );
};

export default MapEditor;
export { LocationMarker, MapController }; 